module.exports = __webpack_public_path__ + "assets/img/m4.a4750ffb.png";